/* Homepage photograph names. No image replacement, link interception or extra SDK. */
(() => {
  'use strict';
  if (window.InspireHomePhotoLabels) return;
  const config = document.getElementById('HomePhotoLabelData'), root = document.querySelector('main');
  if (!config || !root) return;
  const data = JSON.parse(config.textContent);
  window.InspireHomePhotoLabels = true;
  const tooltip = document.createElement('div');
  tooltip.id = 'HomePhotoTooltip'; tooltip.setAttribute('role', 'tooltip'); tooltip.hidden = true;
  document.body.append(tooltip);
  const tracked = new WeakSet();
  let active = null, focusOwner = null, timer = null, lastPoint = null;
  function filename(img) {
    const src = img.getAttribute('src') || img.dataset.src || '';
    try { return decodeURIComponent(new URL(src, location.origin).pathname.split('/').pop()); } catch { return ''; }
  }
  function name(img) {
    const explicit = data.images[filename(img)]; if (explicit) return explicit;
    if (data.titles[img.alt]) return img.alt;
    const card = img.closest('.card-wrapper,.multicolumn-card,article');
    const links = [img.closest('a'), ...(card?.querySelectorAll('a[href]') || [])].filter(Boolean);
    for (const link of links) {
      const handle = new URL(link.href, location.origin).pathname.match(/^\/products\/([^/]+)/)?.[1];
      if (handle && data.products[handle]) return data.products[handle];
    }
    return img.alt?.trim() || 'Hardware inspiration — product not identified';
  }
  function annotate() {
    for (const img of root.querySelectorAll('img')) {
      img.dataset.homePhotoLabel = name(img);
      if (!img.alt) img.alt = img.dataset.homePhotoLabel;
      const box = img.closest('.card-wrapper,.multicolumn-card,.banner__media,.image-with-text__media');
      if (!img.closest('a,button') && !box?.querySelector('a[href]')) img.tabIndex = 0;
    }
  }
  function imageAt(event) {
    if (event.target instanceof HTMLImageElement && root.contains(event.target)) return event.target;
    for (const img of root.querySelectorAll('img[data-home-photo-label]')) {
      const r = img.getBoundingClientRect(), style = getComputedStyle(img);
      if (r.width && r.height && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom) return img;
    }
    return null;
  }
  function position(point) {
    const r = tooltip.getBoundingClientRect(), edge = 12;
    let x = point.x + 14, y = point.y + 18;
    if (x + r.width > innerWidth - edge) x = innerWidth - r.width - edge;
    if (y + r.height > innerHeight - edge) y = point.y - r.height - 12;
    tooltip.style.left = Math.max(edge, x) + 'px'; tooltip.style.top = Math.max(edge, y) + 'px';
  }
  function hide() {
    clearTimeout(timer); timer = null; active = null; tooltip.hidden = true;
    if (focusOwner) {
      const ids = (focusOwner.getAttribute('aria-describedby') || '').split(/\s+/).filter(x => x && x !== tooltip.id);
      if (ids.length) focusOwner.setAttribute('aria-describedby', ids.join(' ')); else focusOwner.removeAttribute('aria-describedby');
      focusOwner = null;
    }
  }
  function show(img, point, owner) {
    hide(); active = img; tooltip.textContent = img.dataset.homePhotoLabel || name(img); tooltip.hidden = false;
    if (owner) { focusOwner = owner; const ids = new Set((owner.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean)); ids.add(tooltip.id); owner.setAttribute('aria-describedby', [...ids].join(' ')); }
    position(point);
    if (!tracked.has(img) && window.InspireEngagement) {
      window.InspireEngagement.track('homepage_photo_labels', 'label_show', filename(img).replace(/[^a-z0-9_-]/gi, '-').slice(0, 100)); tracked.add(img);
    }
  }
  root.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const img = imageAt(event); if (!img) { if (!focusOwner) hide(); return; }
    if (active === img) return;
    hide(); lastPoint = { x: event.clientX, y: event.clientY };
    timer = setTimeout(() => show(img, lastPoint), 250);
  }, { passive: true });
  root.addEventListener('pointermove', event => {
    if (event.pointerType === 'touch') return;
    lastPoint = { x: event.clientX, y: event.clientY };
    if (active && !focusOwner) { const r = active.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) hide(); else position(lastPoint); }
    if (!active && !focusOwner && !timer) { const img = imageAt(event); if (img) timer = setTimeout(() => show(img, lastPoint), 250); }
  }, { passive: true });
  root.addEventListener('pointerleave', () => { if (!focusOwner) hide(); }, { passive: true });
  root.addEventListener('focusin', event => {
    const img = event.target.matches('img') ? event.target : event.target.querySelector('img') || event.target.closest('.card-wrapper,.multicolumn-card,.banner__media,.image-with-text')?.querySelector('img');
    if (!img?.dataset.homePhotoLabel) return;
    const r = img.getBoundingClientRect(); show(img, { x: r.left + Math.min(r.width / 2, 150), y: Math.min(r.bottom, innerHeight - 80) }, event.target);
  });
  root.addEventListener('focusout', hide);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  window.addEventListener('scroll', () => {
    if (focusOwner && active) {
      const r = active.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) position({ x: r.left + Math.min(r.width / 2, 150), y: Math.min(r.bottom, innerHeight - 80) }); else hide();
    } else hide();
  }, { passive: true });
  window.addEventListener('resize', hide, { passive: true });
  annotate();
  let queued = false;
  new MutationObserver(() => { if (!queued) { queued = true; queueMicrotask(() => { queued = false; annotate(); }); } }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-src'] });
})();
